import React from "react";
import CV from "../../assets/Abubakar Mahboob- Resume.pdf";
const CTA = () => {
  return (
    <div className="cta">
      <a href={CV} download className="btn">
        Download CV
      </a>
      {/* <a className="btn">Download CV</a> */}
      <a href="#conntact" className="btn btn-primary">
        Let's Talk
      </a>
    </div>
  );
};

export default CTA;
